A11yToolInitializer = require 'grpn-fix-a11y/lib/initializer'

FixA11y = window.FixA11y ?= {}

FixA11y.init = (payload, done) ->
  {fixA11y} = payload
  return done() unless fixA11y?
  A11yToolInitializer(fixA11y)
  done()

module.exports = FixA11y



// WEBPACK FOOTER //
// ./core/frontend/scripts/vendor_modules/fix-a11y.coffee